/* BEBA YERBA · Ambassador QR maker.
   An ambassador pastes their impact.com referral link once; we draw a branded BEBA YERBA QR card
   on a canvas (no network calls, nothing leaves the browser) and let them save it as a PNG.
   On phones, "Save QR" opens the share sheet so the image can go straight to Photos.
   Used by snippets/beba-qr-maker.liquid (My BEBA refer card + Ambassadors page). */
(function () {
  var C = { green: '#183C30', ink: '#002018', yellow: '#F8C80C', orange: '#F05A0C', white: '#FFFFFF', tint: '#FFF6CF' };
  var FD = '"Lilita One","Arial Rounded MT Bold","Trebuchet MS",system-ui,sans-serif';
  var FB = '"Archivo",system-ui,-apple-system,"Segoe UI",sans-serif';
  var KEY = 'beba-qr-link';
  var libPromise = null;

  /* The QR library is an ES module. It's loaded by a small inline module script in the snippet
     (window.BebaQRCode), because Shopify's asset minifier rewrites dynamic imports in this file into require. */
  function loadLib() {
    if (!libPromise) libPromise = new Promise(function (resolve, reject) {
      if (window.BebaQRCode) return resolve(window.BebaQRCode);
      var t = setTimeout(function () { reject(new Error('QR library did not load')); }, 10000);
      window.addEventListener('beba-qr-lib', function () { clearTimeout(t); resolve(window.BebaQRCode); }, { once: true });
    });
    return libPromise;
  }

  /* Only referral links we recognise: the impact.com short link, the tracking link, or bebayerba.com itself. */
  function cleanLink(raw) {
    var s = (raw || '').trim();
    if (!s) return { error: 'Paste your referral link first.' };
    if (!/^https?:\/\//i.test(s)) s = 'https://' + s;
    var u;
    try { u = new URL(s); } catch (e) { return { error: 'That doesn’t look like a link. Copy it from your ambassador dashboard and paste it here.' }; }
    var h = u.hostname.toLowerCase();
    var ok = h === 'ssqt.co' || /(^|\.)pxf\.io$/.test(h) || h === 'bebayerba.com' || /\.bebayerba\.com$/.test(h);
    if (!ok) return { error: 'Use your BEBA YERBA referral link (it starts with https://ssqt.co/…). You’ll find it in your ambassador dashboard under “Share your referral link”.' };
    if (u.protocol !== 'https:') u.protocol = 'https:';
    return { url: u.toString() };
  }

  function codeFromLink(url) {
    try {
      var u = new URL(url);
      var c = u.searchParams.get('subid1') || u.searchParams.get('rsCode') || u.searchParams.get('p.rsCode');
      return c && /^[A-Za-z0-9_-]{2,40}$/.test(c) ? c.toUpperCase() : '';
    } catch (e) { return ''; }
  }

  function symbolPath(id) {
    var el = document.querySelector('symbol#' + id + ' path');
    if (!el || typeof Path2D === 'undefined') return null;
    var vb = (el.parentNode.getAttribute('viewBox') || '0 0 1 1').split(/\s+/).map(Number);
    return { p: new Path2D(el.getAttribute('d')), w: vb[2], h: vb[3] };
  }

  function rr(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }

  function drawSymbol(ctx, sym, x, y, w, color) {
    if (!sym) return 0;
    var s = w / sym.w, h = sym.h * s;
    ctx.save(); ctx.translate(x, y); ctx.scale(s, s); ctx.fillStyle = color; ctx.fill(sym.p); ctx.restore();
    return h;
  }

  function fitText(ctx, text, font, size, maxW) {
    do { ctx.font = font.replace('{s}', size + 'px'); size -= 2; } while (ctx.measureText(text).width > maxW && size > 18);
  }

  /* 1080×1350 portrait card: right size for a phone screen, Instagram and a print-out. */
  function drawCard(canvas, QRCode, url, opts) {
    var W = 1080, H = 1350, ctx = canvas.getContext('2d');
    canvas.width = W; canvas.height = H;

    ctx.fillStyle = C.yellow; ctx.fillRect(0, 0, W, H);

    var logo = symbolPath('i-logo'), flower = symbolPath('i-flower');
    if (logo) drawSymbol(ctx, logo, 140, 78, 800, C.green);
    else { ctx.fillStyle = C.green; ctx.font = '96px ' + FD; ctx.textAlign = 'center'; ctx.fillText('BEBA YERBA', W / 2, 170); }

    ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = C.green; ctx.font = '800 30px ' + FB;
    ctx.fillText('SCAN FOR ' + opts.offer.toUpperCase() + ' OFF YOUR FIRST ORDER', W / 2, 268);

    /* White panel + QR (error correction H so the centre badge never breaks the scan). */
    var px = 170, py = 300, ps = 740;
    ctx.save(); ctx.shadowColor = 'rgba(0,32,24,.18)'; ctx.shadowOffsetY = 10; ctx.shadowBlur = 0;
    rr(ctx, px, py, ps, ps, 56); ctx.fillStyle = C.green; ctx.fill(); ctx.restore();
    rr(ctx, px, py, ps, ps - 10, 56); ctx.fillStyle = C.white; ctx.fill();

    var holder = document.createElement('div');
    var qr = new QRCode(holder, { text: url, width: 64, height: 64, colorDark: C.green, colorLight: C.white, correctLevel: QRCode.CorrectLevel.H });
    var m = qr._oQRCode, n = m.getModuleCount();
    var area = ps - 120, cell = Math.floor(area / n), size = cell * n;
    var qx = px + Math.round((ps - size) / 2), qy = py + Math.round((ps - 10 - size) / 2);
    ctx.fillStyle = C.green;
    for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) if (m.isDark(r, c)) ctx.fillRect(qx + c * cell, qy + r * cell, cell, cell);

    /* Centre badge: green disc, yellow BEBA flower. ~20% of the code width keeps it scannable. */
    var bd = Math.round(size * 0.2), bx = qx + size / 2, by = qy + size / 2;
    ctx.beginPath(); ctx.arc(bx, by, bd / 2 + 10, 0, Math.PI * 2); ctx.fillStyle = C.white; ctx.fill();
    ctx.beginPath(); ctx.arc(bx, by, bd / 2, 0, Math.PI * 2); ctx.fillStyle = C.green; ctx.fill();
    if (flower) { var fw = bd * 0.78; drawSymbol(ctx, flower, bx - fw / 2, by - (flower.h * fw / flower.w) / 2, fw, C.yellow); }

    /* Footer: code pill (when we know it) + site. */
    var y = py + ps + 64;
    if (opts.code) {
      ctx.font = '800 26px ' + FB; ctx.fillStyle = C.green; ctx.fillText('OR USE CODE', W / 2, y);
      fitText(ctx, opts.code, '{s} ' + FD, 64, 760);
      var tw = Math.min(840, ctx.measureText(opts.code).width + 90);
      rr(ctx, (W - tw) / 2, y + 16, tw, 92, 46); ctx.fillStyle = C.green; ctx.fill();
      ctx.fillStyle = C.yellow; ctx.fillText(opts.code, W / 2, y + 84);
      y += 176;
    } else {
      y += 40;
    }
    ctx.fillStyle = C.green; ctx.font = '800 30px ' + FB;
    ctx.fillText('BEBAYERBA.COM', W / 2, Math.min(y, H - 48));
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var form = root.querySelector('.bq-form'), input = root.querySelector('.bq-input'), codeIn = root.querySelector('.bq-code');
    var msg = root.querySelector('.bq-msg'), out = root.querySelector('.bq-out'), img = root.querySelector('.bq-img');
    var canvas = document.createElement('canvas'), pasteBtn = root.querySelector('.bq-paste');
    var saveBtn = root.querySelector('.bq-save'), shareBtn = root.querySelector('.bq-share'), resetBtn = root.querySelector('.bq-out .bq-reset');
    var offer = root.dataset.offer || '15%', current = null, blob = null;

    function say(t, bad) { msg.textContent = t; msg.hidden = !t; msg.classList.toggle('is-bad', !!bad); }
    function store(v) { try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {} }
    function stored() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
    function fileName() { return 'BEBA-YERBA-QR' + (current && current.code ? '-' + current.code : '') + '.png'; }

    function build(link, code, quiet) {
      var res = cleanLink(link);
      if (res.error) { if (!quiet) { say(res.error, true); input.focus(); } return; }
      var c = (code || '').trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '') || codeFromLink(res.url);
      say('Making your QR code…');
      var fontsReady = document.fonts && document.fonts.load
        ? Promise.all([document.fonts.load('64px "Lilita One"'), document.fonts.load('800 30px "Archivo"')]).catch(function () {})
        : Promise.resolve();
      Promise.all([loadLib(), fontsReady]).then(function (r) {
        drawCard(canvas, r[0], res.url, { offer: offer, code: c });
        current = { link: res.url, code: c };
        store(current);
        input.value = res.url; if (codeIn) codeIn.value = c;
        canvas.toBlob(function (b) {
          blob = b;
          if (img.src && img.src.indexOf('blob:') === 0) URL.revokeObjectURL(img.src);
          img.src = URL.createObjectURL(b);
          img.alt = 'Your BEBA YERBA QR code for ' + res.url;
          form.hidden = true; out.hidden = false;
          say(quiet ? '' : 'Your QR code is ready. Save it to your phone or share it.');
        }, 'image/png');
      }).catch(function (err) { if (window.console) console.error('[BEBA QR]', err); say('Couldn’t make the QR code on this browser. Try again, or open this page in Safari or Chrome.', true); });
    }

    function asFile() { try { return new File([blob], fileName(), { type: 'image/png' }); } catch (e) { return null; } }
    function canShareFile() { var f = asFile(); return !!(f && navigator.canShare && navigator.canShare({ files: [f] })); }
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

    function download() {
      var a = document.createElement('a'); a.href = img.src; a.download = fileName();
      document.body.appendChild(a); a.click(); a.remove();
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); build(input.value, codeIn && codeIn.value); });

    if (pasteBtn) {
      if (!(navigator.clipboard && navigator.clipboard.readText)) pasteBtn.hidden = true;
      pasteBtn.addEventListener('click', function () {
        navigator.clipboard.readText().then(function (t) { input.value = (t || '').trim(); if (input.value) build(input.value, codeIn && codeIn.value); })
          .catch(function () { say('Tap the box and paste your link there.', false); input.focus(); });
      });
    }

    saveBtn.addEventListener('click', function () {
      if (!blob) return;
      /* Phones: the share sheet has "Save Image" → Photos. Desktop: a normal PNG download. */
      if (touch && canShareFile()) {
        navigator.share({ files: [asFile()], title: 'My BEBA YERBA QR code' }).catch(function (err) { if (!err || err.name !== 'AbortError') download(); });
      } else { download(); say('Saved as ' + fileName() + '.'); }
    });

    if (shareBtn) {
      if (!navigator.share) shareBtn.hidden = true;
      shareBtn.addEventListener('click', function () {
        if (!current) return;
        var text = 'Try BEBA YERBA! Get ' + offer + ' off your first order with my link' + (current.code ? ' or code ' + current.code : '') + '.';
        var data = canShareFile() ? { files: [asFile()], text: text + ' ' + current.link } : { text: text, url: current.link };
        navigator.share(data).catch(function () {});
      });
    }

    resetBtn.addEventListener('click', function () {
      var ab = root.querySelector('.bq-auto'); if (ab) ab.hidden = true;
      out.hidden = true; form.hidden = false; say(''); store(null); input.value = ''; if (codeIn) codeIn.value = ''; input.focus();
    });

    var saved = stored();
    if (root.hasAttribute('data-auto')) autoFill(saved);
    else if (saved && saved.link) build(saved.link, saved.code, true);

    /* Signed-in ambassadors: the theme signed their email; the lookup service returns their
       impact.com link + code. Any failure falls back to the paste form, so nobody is stuck. */
    function autoFill(saved) {
      var box = root.querySelector('.bq-auto'), loading = root.querySelector('.bq-loading');
      var mine = root.querySelector('.bq-mine'), none = root.querySelector('.bq-none'), gen = root.querySelector('.bq-gen');
      var found = null;
      function manual(note) {
        box.hidden = true; form.hidden = false; say(note || '', false);
        if (saved && saved.link) build(saved.link, saved.code, true);
      }
      var u;
      try {
        u = new URL(root.dataset.lookup);
        u.searchParams.set('e', root.dataset.e); u.searchParams.set('t', root.dataset.t); u.searchParams.set('s', root.dataset.s);
      } catch (e) { return manual(); }
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
      fetch(u.toString(), { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('lookup ' + r.status); return r.json(); })
        .then(function (d) {
          clearTimeout(timer); loading.hidden = true;
          if (!d || !d.found || !d.link) { none.hidden = false; return; }
          var clean = cleanLink(d.link);
          if (clean.error) throw new Error('unexpected link');
          found = { link: clean.url, code: (d.code || '').toUpperCase() };
          root.querySelector('.bq-val-link').textContent = found.link.replace(/^https:\/\//, '');
          var cv = root.querySelector('.bq-val-code');
          cv.textContent = found.code; root.querySelector('.bq-code-wrap').hidden = !found.code;
          mine.hidden = false;
          /* Same link as last time on this phone: show the QR straight away. */
          if (saved && saved.link === found.link) { gen.hidden = true; build(found.link, found.code, true); }
        })
        .catch(function (err) {
          clearTimeout(timer);
          if (window.console) console.warn('[BEBA QR] lookup', err && err.message);
          manual('We couldn’t load your link automatically. Paste it below and we’ll make your QR code.');
        });

      gen.addEventListener('click', function () { if (!found) return; gen.hidden = true; build(found.link, found.code); });
      root.querySelectorAll('.bq-copy').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!found) return;
          var v = b.dataset.what === 'code' ? found.code : found.link;
          var ok = function () { var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1600); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(ok, function () { say(v); });
          else say(v);
        });
      });
      var m = root.querySelector('.bq-manual');
      if (m) m.addEventListener('click', function () { manual(); input.focus(); });
    }
  }

  function boot() { document.querySelectorAll('[data-beba-qr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
